import { html } from "lit";
import { when } from "lit-html/directives/when.js";
import { consume } from "@lit/context";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { tabContext } from "../Tabs/index.js";
import "../../atom/Column/index.js";
import "../../atom/Row/index.js";
import "../../atom/Text/index.js";
import "../Badge/index.js";
import { getClasses, getIconClasses, getTitleClasses, getTitleSize, getBadgeClasses, getSubtitleSize, getVerticalArrowClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfTab = class extends BaseComponent {
  onClick() {
    var _a;
    if (this.dsf_slot !== ((_a = this.tabsCtx) == null ? void 0 : _a.value)) {
      this.emit({ name: "tab-change", payload: this.dsf_slot || "" });
    }
  }
  render() {
    var _a, _b, _c;
    return html`
      <button
        @click=${this.onClick}
        class=${getClasses(this)}
        role="tab"
        type="button"
        data-skeleton
      >
        ${when(
      this.dsf_icon,
      () => html`<dsf-icon class=${getIconClasses(this)} dsf_name=${this.dsf_icon}></dsf-icon>`
    )}
        <div>
          <dsf-row dsf_align="center">
            <dsf-text class=${getTitleClasses(this)} dsf_level=${getTitleSize(this)}
              >${this.dsf_title}</dsf-text
            >
            ${when(
      this.dsf_counter && ((_a = this.tabsCtx) == null ? void 0 : _a.direction) === "horizontal",
      () => html`<dsf-badge dsf_size="small" class=${getBadgeClasses(this)}
                  >${this.dsf_counter}</dsf-badge
                >`
    )}
          </dsf-row>
          <dsf-text dsf_color_intensity="400" dsf_level=${getSubtitleSize(this)}
            >${this.dsf_subtitle}</dsf-text
          >
        </div>
        <div class="row flex h-16 items-end justify-center">
          ${when(
      this.dsf_counter && ((_b = this.tabsCtx) == null ? void 0 : _b.direction) === "vertical",
      () => html`<dsf-badge dsf_size="small" class=${getBadgeClasses(this)}
                >${this.dsf_counter}</dsf-badge
              >`
    )}
          ${when(
      ((_c = this.tabsCtx) == null ? void 0 : _c.direction) === "vertical",
      () => html`
                <dsf-icon dsf_name="ChevronRight" class=${getVerticalArrowClasses()}></dsf-icon>
              `
    )}
        </div>
      </button>
    `;
  }
};
__decorateClass([
  consume({ context: tabContext, subscribe: true }),
  prop({ attribute: false })
], DsfTab.prototype, "tabsCtx", 2);
__decorateClass([
  prop({ type: String })
], DsfTab.prototype, "dsf_slot", 2);
__decorateClass([
  prop({ type: String })
], DsfTab.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: String })
], DsfTab.prototype, "dsf_icon", 2);
__decorateClass([
  prop({ type: String })
], DsfTab.prototype, "dsf_subtitle", 2);
__decorateClass([
  prop({ type: Number })
], DsfTab.prototype, "dsf_counter", 2);
DsfTab = __decorateClass([
  defineElement("dsf-tab")
], DsfTab);
export {
  DsfTab
};
